import AddIcon from '@mui/icons-material/Add';

const MaterialAddIcon = () => {
  return <AddIcon htmlColor="#1A1A1A"></AddIcon>;
};

export default MaterialAddIcon;
